<ggi-journey-modal-are-you-sure
  [data]="dataModalAreYouSure"
  *ngIf="isModalAreYouSureActive"
></ggi-journey-modal-are-you-sure>
